// extracted by mini-css-extract-plugin
export default {"voucherTitle":"VoucherView_voucherTitle__pU+P9","voucherButtons":"VoucherView_voucherButtons__4essC","voucherApiError":"VoucherView_voucherApiError__X5nwu"};